import BottomSheet from "@/shared/ui/BottomSheet";
import LoginForm from "./LoginForm";
import styles from "./MockLoginSheet.module.scss";

type MockLoginSheetProps = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * 숨김 ID/PW 로그인 시트(dev 전용 review-login).
 * 소셜 로그인 화면 로고 10탭 제스처로만 열린다(useSecretTap).
 * LoginForm 은 POST /auth/review/login 을 호출한다(mock 아님).
 */
const MockLoginSheet = ({ isOpen, onClose }: MockLoginSheetProps) => {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="ID/PW 로그인"
    >
      <div className={styles.body}>
        <LoginForm onSuccess={onClose} />
      </div>
    </BottomSheet>
  );
};

MockLoginSheet.displayName = "MockLoginSheet";

export default MockLoginSheet;
